import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import router from './router';
import store from './store';
import Axios from 'axios';
import VueMeta from 'vue-meta';
import stickyDirective from '@/directives/sticky';
import toast from '@/plugins/toast';
import dateFilter from '@/filters/date';
import timerFilter from '@/filters/timer';
import VueScrollTo from 'vue-scrollto';
import './plugins/bootstrap-vue';
import './registerServiceWorker';
import '@/assets/external/app.js';

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
const token = localStorage.getItem('u-access');
if (token) {
  Vue.prototype.$http.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${token}`;
}

Vue.directive('stcky', stickyDirective);
Vue.use(Vuelidate);
Vue.use(toast);
Vue.use(VueScrollTo);
Vue.use(VueMeta);
Vue.filter('date', dateFilter);
Vue.filter('timer', timerFilter);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
